import React, { useEffect, useState } from 'react';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { AppContext } from '../../contexts/AppContext.js';
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import i18n from '../../i18n/i18n.js';
import { Utils } from '../../Utils.js';

import './LostPassword.css';



const LostPassword = (props) => {

    const [appState, setAppState] = useState({});
    const [isVisible, setIsVisible] = useState(true);
    const [display, setDisplay] = useState(props.display || 'lost_password');
    
    const navigate = useNavigate();

    function requestSigInCode(e) {

        e.preventDefault();

        const email = document.getElementById('lost_password_email').value;

        Utils.get_server_data(
            '', 
            {ajax_event: 'lost_password'}, 
            {email: email}
        ).then((response)=>{
            if(response?.lost_password_msg?.success === true){
                Utils.localSorageSetWithExpiry('login_email_' + i18n.resolvedLanguage, email, 900000); 
                navigate('/sign-in?message=otp_sent');
            }else{
                alert(i18n.t('lostPasswordError'));
            }
        })
    };

    return <AnimatePresence>
        {isVisible && (
        <motion.div 
            className={`container floating_container page_forgot_password`}
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
        >
            <div className="content">
                <PageHeader isHistoryBack={true} callback={() => {setIsVisible(false)}} no_close={true} title={i18n.t('lostPasswordTitle')}></PageHeader>

                <div className='form_wapper' onSubmit={(e)=>requestSigInCode(e)}>

                    {display=='lost_password' ?
                    <div className="form_description">
                        {i18n.t('lostPasswordText')}
                    </div>
                    :
                    <>
                    <div className="form_description">
                        {i18n.t('lostPasswordSentText')}
                    </div>
                    </>}

                    {display=='lost_password' &&
                        <form className="lost_password_form">
                            <div className="form_group">
                                <input type="email" required={true} placeholder={i18n.t('lostPasswordEmail')} id="lost_password_email" name="lost_password_email" />
                            </div>
                            <div className='form_submit'>
                                <input className='submit_btn' type="submit" value={i18n.t('lostPasswordSubmit')} />
                            </div>
                        </form>
                    }
                </div>
                
            </div>
        </motion.div>
        )}
    </AnimatePresence>;
}

export default LostPassword;